import CriticalImage from "../../../atoms/image/CriticalImage";
import TpWidgetMicro from "../../common/TpWidgetMicro";
import {
  viewport,
  colors,
  font,
  lineHeight,
} from "../../../../styles/cssinjs/helpers/variables.js";

export default function Hero({ className, data, colorCode }) {
  return (
    <section
      className={`container hero--default lg:mb-15 md:mb-10 ${
        className ? className : ""
      }`}
    >
      <article>
        <figure>
          <CriticalImage
            src={data.image.src}
            type={data.image.type}
            mobile="mobile"
            dpi="-2x"
            imgClass=""
            wrapClass=""
            alt={data.image.alt}
            width="1160"
            height="auto"
          />
        </figure>
        <div className="content">
          <h1 className={`text-xl has-line --${colorCode}`}>{data.title}</h1>
          <p className="lg:mr-10">{data.desc}</p>
          <TpWidgetMicro className={`fx fx--cv md:mt-2.5 lg:d-none`} />
        </div>
      </article>
      <style jsx>{`
        .has-line:after {
          content: "";
          display: block;
          width: 80px;
          height: 8px;
          margin-top: 32px;
          border-radius: 8px;
        }
        .--yellow:after {
          background-color: ${colors.primitive.yellow.default};
        }
        .--orange:after {
          background-color: ${colors.primitive.red[300]};
        }
        .--red:after {
          background-color: ${colors.primitive.red[200]};
        }
        .--green:after {
          background-color: ${colors.primitive.green[400]};
        }
        .--blue:after {
          background-color: ${colors.derived.brand};
        }
        .--violet:after {
          background-color: ${colors.primitive.violet[200]};
        }
        .--grey:after {
          background-color: ${colors.primitive.grey[900]};
        }
        figure {
          border-radius: 8px;
          overflow: hidden;
        }

        @media (min-width: ${viewport.tablet.sm}) {
          article {
            position: relative;
          }
          figure {
            position: absolute;
            top: 0;
            bottom: 0;
            right: 0;
            left: 0;
            z-index: -1;
          }

          figure :global(img),
          figure :global(picture) {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
          .content {
            padding: 40px 0px 48px 40px;
            color: ${colors.primitive.white.default};
            max-width: 620px;
          }
          h1,
          p {
            color: ${colors.primitive.white.default};
          }
        }
        @media (max-width: ${viewport.tablet.sm}) {
          .has-line:after {
            margin-top: 20px;
          }
          .content {
            margin-top: 32px;
          }
        }
      `}</style>
    </section>
  );
}
